import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useFeatures } from "../context/FeatureContext";

/**
 * FeatureGate — renders children when the caller's role has `feature`
 * enabled in the toggle matrix, otherwise shows a friendly locked screen.
 * Loading state passes through (child renders) to avoid a flash of the
 * locked screen before /settings comes back.
 */
export default function FeatureGate({ feature, children, fallback = null }) {
  const { canUse, loading } = useFeatures();
  if (loading) return children;
  if (canUse(feature)) return children;
  if (fallback !== null) return fallback;
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-8"
         data-testid={`feature-locked-${feature}`}>
      <div className="p-10 border border-[var(--line)] bg-white max-w-md text-center">
        <div className="mx-auto mb-4 w-12 h-12 flex items-center justify-center bg-[var(--surface-2)]">
          <Lock size={20} className="muted" />
        </div>
        <div className="label mb-2">Access restricted</div>
        <div className="font-display text-lg font-semibold mb-2">
          <span className="font-mono">{feature}</span> is disabled for your role
        </div>
        <div className="text-xs muted mb-5">
          Ask an administrator to enable this feature in Settings → Feature toggles.
        </div>
        <Link to="/dashboard" className="btn-ghost">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
